import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Button from '../Buttons';
import Icon from '../Icon';
import DayMonth from '../DayMonth';

const FormEvent = styled.form`
  font-size: ${rem('13px')};
  height: 100vh;
  padding: ${rem('80px')} ${rem('30px')} ${rem('30px')} ${rem('30px')};
  margin-top: ${rem('30px')};
  position: relative;
  padding: ${rem('50px')} 1.875rem 1.875rem 1.875rem;
  ${mediaqueries.greaterThan('desktop')`
    height: 100%;
  `};
`;

const Event = styled.div`
  font-size: ${rem('13px')};
  height: 100vh;
  padding: ${rem('80px')} ${rem('30px')} ${rem('30px')} ${rem('30px')};
  margin-top: ${rem('30px')};
  position: relative;
  padding: ${rem('50px')} 1.875rem 1.875rem 1.875rem;
  ${mediaqueries.greaterThan('desktop')`
    height: 100%;
  `};
`;

const DivFlex = styled.div`
  align-items: flex-end;
  display: flex;
`;

const DivCenter = styled.div`
  position: relative;
  ${mediaqueries.greaterThan('desktop')`
    transform: translateY(-25%);
    top: 25%;
  `};
`;

const DivScroll = styled.div`
  overflow-y: auto;
  padding-right: 1rem;
  width: calc(100% + 1.8rem);
  ${mediaqueries.greaterThan('mobile')`
    max-height: ${rem('225px')};
  `};
`;

const DayMonthEvent = styled(DayMonth)`
  width: 100%;
`;

const IconsEvent = styled(Icon)`
  flex: 0 0 ${rem('24px')};
  margin-right: 0.3rem;
  position: relative;

  ${mediaqueries.greaterThan('desktop')`
    float: left;
  `};
`;

const IconEventClose = styled(Icon)`
  cursor: pointer;
  position: absolute;

  right: ${rem('30px')};
  top: 0;
  width: ${rem('19px')};
  height: ${rem('19px')};

  ${mediaqueries.greaterThan('desktop')`
    height: ${rem('16px')};
    left: ${rem('30px')};
    right: initial;
    top: ${rem('20px')};
    width: ${rem('16px')};
  `};
`;

const StrongMedium = styled.strong`
  font-family: ${props => props.theme.fonts.medium};
`;

const EventDayDate = styled.span`
  display: inline-block;
  min-width: ${rem('110px')};
`;

const TitleEvent = styled.h3`
  font-size: ${rem('16px')};
  margin: ${rem('30px')} 0 ${rem('10px')};
  text-transform: none;
`;

const ElementEvent = styled.p`
  align-items: center;
  display: flex;
  font-size: inherit;
  line-height: 1.14;
  margin-bottom: ${rem('12px')};
`;

const DateEvent = ElementEvent.extend`
  align-items: flex-start;
  font-family: ${props => props.theme.fonts.medium};

  ${IconsEvent} {
    top: 0;
  }
`;

const DescEvent = ElementEvent.extend`
  font-size: ${rem('14px')};
`;

const DateRange = styled.time`
  display: block;
  margin-bottom: ${rem('5px')};
  padding-left: ${rem('6px')};
`;

const LinksEvent = styled.a`
  display: flex;
  font-family: ${props => props.theme.fonts.medium};
`;

const LinkNews = LinksEvent.extend`
  font-size: ${rem('12px')};
  text-transform: uppercase;
  font-weight: 700;
`;

const WrapperButtons = styled.div`
  margin-top: ${rem('20px')};
`;

const EventButton = styled(Button)`
  background-color: ${props => props.theme.colors.grayDarkest};
  border: ${rem('2px')} solid ${props => props.theme.colors.grayDarkest};
  font-size: inherit;
  font-variant: small-caps;
  height: auto;
  margin-right: ${rem('20px')};
  padding: ${rem('6px')} 1.25rem;
  text-transform: lowercase;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${props => props.theme.colors.grayDarkest};
  }

  &:last-child {
    margin-right: 0;
  }

  ${props =>
    props.acceptedEvent &&
    `
      background-color: ${props.theme.colors.primary};
      border-color: ${props.theme.colors.primary};
  `};
`;

const EventButtonInvested = EventButton.extend`
  background: none;
  border-color: inherit;
  color: ${props => props.theme.colors.grayDarkest};

  &:hover {
    color: ${props => props.theme.colors.light};
  }

  ${props =>
    props.rejectedEvent &&
    `
      color: ${props.theme.colors.primary};
  `};
`;

const StyledDates = styled.p`
  font-size: ${rem('12px')};
  font-family: ${props => props.theme.fonts.bold};
  margin: 0;
  margin-bottom: ${rem('5px')};

  &:first-child {
    margin-top: ${rem('15px')};
  }
`;

export {
  FormEvent,
  DivFlex,
  DivCenter,
  DivScroll,
  DayMonthEvent,
  IconsEvent,
  IconEventClose,
  EventDayDate,
  StrongMedium,
  TitleEvent,
  ElementEvent,
  DescEvent,
  DateEvent,
  DateRange,
  LinksEvent,
  LinkNews,
  WrapperButtons,
  EventButton,
  EventButtonInvested,
  StyledDates,
  Event
};
